<template>
  <Modal 
    @closed="$emit('close')" 
    id="vlw_user_statistics" 
    class="vlw_user_statistics" 
    title="Mijn contacten" 
    :open="true" 
    :closable="true"
  >
    <div class="vl-layout mb-4">
      <div class="vl-form-grid vl-form-grid--is-stacked">
        <div class="vl-form-col--4-12">
          <label class="vl-form__label vl-form__label __field__label">Vanaf</label>
          <div class="vl-input-group vl-datepicker">
            <Datepicker 
              :defaultValue="sinceDate" 
              @input="updateDatePicker" 
            />
          </div>
          
        </div>
        
        <div class="vl-form-col--4-12">
          <label for="interactionType" class="vl-form__label vl-form__label __field__label">Interactie type</label>
          <select id="interactionType" v-model="selectedFilter" class="vl-select--block vl-select vl-select--block">
            <option value="all">Alles</option>
            <option value="chats">Chats</option>
            <option value="emails">E-mails</option>
            <option value="calls">Oproepen</option>
            <option value="teletolk">Teletolk</option>
          </select>
        </div>
        
        <div class="vl-form-col--4-12">
          <label for="pageSize" class="vl-form__label vl-form__label __field__label">Per pagina</label>
          <select id="pageSize" v-model.number="pageSize" class="vl-select--block vl-select vl-select--block">
            <option v-for="s in pageSizes" :key="s" :value="s">{{ s }}</option>
          </select>
        </div>
      </div>

      <template v-if="isLoading">
        <div class="flex justify-center items-center h-64">
          <span class="ml-2">Je gegevens worden opgehaald
            <VlLoader class="mt-2 text-center" />
          </span>
        </div>
      </template>

      <div v-else>
        <section class="pt-6">
          <div class="vl-description-data text-center border border-gray-300 rounded-lg p-4 bg-gray-50 dark:bg-zinc-900/50 dark:border-zinc-700">
            <dl class="vl-grid vl-grid--is-stacked">
              <div class="vl-col--1-4 vl-col--1-2--s vl-col--1-2--xs">
                <dt class="vl-description-data__label">Chats</dt>
                <dd class="vl-description-data__value">{{ chatCount }}</dd>
              </div>
              
              <div class="vl-col--1-4 vl-col--1-2--s vl-col--1-2--xs">
                <dt class="vl-description-data__label">E-mails</dt>
                <dd class="vl-description-data__value">{{ emailCount }}</dd>
              </div>
              
              <div class="vl-col--1-4 vl-col--1-2--s vl-col--1-2--xs">
                <dt class="vl-description-data__label">Oproepen</dt>
                <dd class="vl-description-data__value">{{ callCount }}</dd>
              </div>
              
              <div class="vl-col--1-4 vl-col--1-2--s vl-col--1-2--xs">
                <dt class="vl-description-data__label">Teletolk</dt>
                <dd class="vl-description-data__value">{{ teletolkCount }}</dd>
              </div>
            </dl>
          </div>
        </section>

        <!-- Datatable-->    
        <section class="pt-2">
          <table class="vl-data-table vl-data-table--grid vl-data-table--collapsed-m vl-data-table--zebra">
            <thead>
              <tr>
                <th>
                  <div 
                    class="sortable-header" 
                    role="button" 
                    tabindex="0" 
                    @click="toggleSort('type')" 
                    @keydown.enter.prevent="toggleSort('type')" 
                    @keydown.space.prevent="toggleSort('type')"
                  >
                    <span>Type</span>
                    <span v-if="sortKey === 'type'">
                      <span v-if="sortDir === 'asc'" class="vl-icon vl-vi vl-vi-nav-up-light" aria-hidden="true"></span>
                      <span v-else class="vl-icon vl-vi vl-vi-nav-down-light" aria-hidden="true"></span>
                    </span>
                  </div>
                </th>
                <th>
                  <div 
                    class="sortable-header" 
                    role="button" 
                    tabindex="0" 
                    @click="toggleSort('contactId')"
                    @keydown.enter.prevent="toggleSort('contactId')" 
                    @keydown.space.prevent="toggleSort('contactId')"
                  >
                    <span>Contact ID</span>
                    <span v-if="sortKey === 'contactId'">
                      <span v-if="sortDir === 'asc'" class="vl-icon vl-vi vl-vi-nav-up-light" aria-hidden="true"></span>
                      <span v-else class="vl-icon vl-vi vl-vi-nav-down-light" aria-hidden="true"></span>
                    </span>
                  </div>
                </th>
                <th>
                  <div 
                    class="sortable-header" 
                    role="button" 
                    tabindex="0" 
                    @click="toggleSort('id')" 
                    @keydown.enter.prevent="toggleSort('id')" 
                    @keydown.space.prevent="toggleSort('id')"
                  >
                    <span>Interaction ID</span>
                    <span v-if="sortKey === 'id'">
                      <span v-if="sortDir === 'asc'" class="vl-icon vl-vi vl-vi-nav-up-light" aria-hidden="true"></span>
                      <span v-else class="vl-icon vl-vi vl-vi-nav-down-light" aria-hidden="true"></span>
                    </span>
                  </div>
                </th>
                <th>
                  <div 
                    class="sortable-header" 
                    role="button" 
                    tabindex="0" 
                    @click="toggleSort('workgroup')" 
                    @keydown.enter.prevent="toggleSort('workgroup')" 
                    @keydown.space.prevent="toggleSort('workgroup')"
                  >
                    <span>Werkgroep</span>
                    <span v-if="sortKey === 'workgroup'">
                      <span v-if="sortDir === 'asc'" class="vl-icon vl-vi vl-vi-nav-up-light" aria-hidden="true"></span>
                      <span v-else class="vl-icon vl-vi vl-vi-nav-down-light" aria-hidden="true"></span>
                    </span>
                  </div>
                </th>
                <th>
                  <div 
                    class="sortable-header" 
                    role="button" 
                    tabindex="0" 
                    @click="toggleSort('date')" 
                    @keydown.enter.prevent="toggleSort('date')" 
                    @keydown.space.prevent="toggleSort('date')"
                  >
                    <span>Datum</span>
                    <span v-if="sortKey === 'date'">
                      <span v-if="sortDir === 'asc'" class="vl-icon vl-vi vl-vi-nav-up-light" aria-hidden="true"></span>
                      <span v-else class="vl-icon vl-vi vl-vi-nav-down-light" aria-hidden="true"></span>
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedRecentInteractions" :key="item.id">
                <td data-title="Type">{{ readableType(item.type) }}</td>
                <td data-title="Contact ID">{{ item.contactId || '-' }}</td>
                <td data-title="Interaction ID">{{ item.id }}</td>
                <td data-title="Werkgroep">{{ (item.data && (item.data.processingContentTheme || item.data.workgroup)) || '-' }}</td>
                <td data-title="Tijd">{{ formatDate(item.date) }}</td>
              </tr>
              <tr v-if="filteredRecentInteractions.length === 0">
                <td colspan="5" class="text-muted text-center">Geen recente interacties gevonden.</td>
              </tr>
            </tbody>
          </table>
          
          <div class="mt-4 flex items-right justify-between">
            <div class="text-gray-600">
              {{ startItem }} - {{ endItem }} van {{ totalItems }}
            </div>
            
            <div class="flex items-center gap-2">
              <button 
                class="vl-button" 
                :disabled="pageCount <= 1 || currentPage <= 1 || filteredRecentInteractions.length === 0"
                @click="prevPage">
                Vorige
              </button>
              <button 
                class="vl-button" 
                :disabled="pageCount <= 1 || currentPage >= pageCount || filteredRecentInteractions.length === 0" 
                @click="nextPage">
                Volgende
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  INCOMING_CHAT,
  INCOMING_CALL,
  INCOMING_EMAIL,
  OUTGOING_CALL,
  OUTGOING_CALL_BACKOFFICE,
  MANUAL_OUTGOING_CALL_BACKOFFICE,
  EXTERNAL_TICKET,
  RECALL,
  TELETOLK,
} from '@/constants';
import Datepicker from '@/components/shared/Datepicker.vue';

function defaultSinceDate(days = 30) {
  const d = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
  return d.toISOString().slice(0, 10);
}

export default {
  name: 'UserStatistics',
  components: { Datepicker },
  data() {
    return {
      selectedFilter: 'all',
      history: [],
      isLoading: false,
      historyError: null,
      sinceDate: defaultSinceDate(30),
      // pagination
      currentPage: 1,
      pageSize: 5,
      pageSizes: [5, 8, 10, 20],
      // sorting
      sortKey: 'date',
      sortDir: 'desc', // 'asc' | 'desc'
    };
  },
  watch: {
    pageSize() { this.currentPage = 1; },
    history() { this.__resetPagination(); },
    selectedFilter() { this.__resetPagination(); },
  },
    async mounted() {
      await this.getUserHistory();
    },
  computed: {
    chatCount() {
      return (this.mappedHistory || []).filter(i => i.type === INCOMING_CHAT).length;
    },
    emailCount() {
      return (this.mappedHistory || []).filter(i => i.type === INCOMING_EMAIL).length;
    },
    callCount() {
        const calls = [
            INCOMING_CALL, 
            OUTGOING_CALL, 
            OUTGOING_CALL_BACKOFFICE, 
            MANUAL_OUTGOING_CALL_BACKOFFICE, 
            RECALL
        ];
        
        return (this.mappedHistory || []).filter(i => calls.includes(i.type)).length;
    },
    recentInteractions() {
      // mappedHistory is already sorted descending by date
      return (this.mappedHistory || []).slice(0, 8);
    },
    mappedHistory() {
      if (!this.history || !this.history.length) return [];

      return this.history
        .map(h => {
          const rawId = h.interactionId || h.id || '';

          return {
            // only show the interaction id (before first ;)
            id: typeof rawId === 'string'
              ? rawId.split(';')[0]
              : rawId,

            contactId: h.contactNumber,
            type: h.channel,
            data: {
              interactionWorkgroup: h.workGroup,
              processingContentTheme: h.processingContentTheme,
              contactSubStatus: h.contactSubStatus,
              raw: h,
            },
            date: h.createdOn,
          };
        })
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    teletolkCount() {
      return (this.mappedHistory || []).filter(i => i.type === TELETOLK).length;
    },
    filteredRecentInteractions() {
      const source = (this.mappedHistory && this.mappedHistory.length) ? this.mappedHistory : this.recentInteractions;
      if (this.selectedFilter === 'all') return source;

      const calls = [INCOMING_CALL, OUTGOING_CALL, OUTGOING_CALL_BACKOFFICE, MANUAL_OUTGOING_CALL_BACKOFFICE, RECALL];
      const chats = [INCOMING_CHAT];
      const emails = [INCOMING_EMAIL];
      const tickets = [EXTERNAL_TICKET];
      const teletolk = [TELETOLK];

      switch (this.selectedFilter) {
        case 'calls':
          return source.filter(i => calls.includes(i.type));
        case 'chats':
          return source.filter(i => chats.includes(i.type));
        case 'emails':
          return source.filter(i => emails.includes(i.type));
        case 'tickets':
          return source.filter(i => tickets.includes(i.type));
        case 'teletolk':
          return source.filter(i => teletolk.includes(i.type));
        default:
            return this.recentInteractions;
      }
    },
      // apply sorting before pagination
      sortedRecentInteractions() {
        const src = (this.filteredRecentInteractions || []).slice();
        if (!this.sortKey) return src;

        const dir = this.sortDir === 'asc' ? 1 : -1;

        src.sort((a, b) => {
          let va = '';
          let vb = '';

          switch (this.sortKey) {
            case 'type':
              va = String(a.type || '').toLowerCase();
              vb = String(b.type || '').toLowerCase();
              break;
            case 'contactId':
              va = String(a.contactId || '').toLowerCase();
              vb = String(b.contactId || '').toLowerCase();
              break;
            case 'id':
              va = String(a.id || '').toLowerCase();
              vb = String(b.id || '').toLowerCase();
              break;
            case 'workgroup':
              va = String((a.data && (a.data.processingContentTheme || a.data.workgroup)) || '').toLowerCase();
              vb = String((b.data && (b.data.processingContentTheme || b.data.workgroup)) || '').toLowerCase();
              break;
            case 'date':
            default:
              return (new Date(b.date) - new Date(a.date)) * dir;
          }

          if (va < vb) return -1 * dir;
          if (va > vb) return 1 * dir;
          return 0;
        });

        return src;
      },
    totalItems() {
      return (this.filteredRecentInteractions || []).length;
    },
    pageCount() {
      return Math.ceil(this.totalItems / this.pageSize) || 0;
    },
    startItem() {
      if (!this.totalItems) return 0;
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endItem() {
      if (!this.totalItems) return 0;
      return Math.min(this.currentPage * this.pageSize, this.totalItems);
    },
    paginatedRecentInteractions() {
      const src = this.sortedRecentInteractions || [];
      if (!src.length) return [];
      const start = (this.currentPage - 1) * this.pageSize;
      return src.slice(start, start + this.pageSize);
    },
  },
  methods: {
      async getUserHistory(since) {
        this.isLoading = true;
        this.historyError = null;

        try {
          const param = since || this.sinceDate;
          const res = await this.$store.dispatch('contact/getHistory', param);
          if (res && res.data) {
            this.history = res.data;
          } else if (res && res.empty) {
            this.history = [];
          }
                
        } catch (err) {
          this.historyError = err;
          console.error('failed to get user history', err);
        } finally {
          this.isLoading = false;
        }
      },
      updateDatePicker(value) {
        this.sinceDate = value;
        this.getUserHistory(value);
    },
      // reset to first page when page size changes or history updates
      __resetPagination() {
        this.currentPage = 1;
      },
    toggleSort(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        // default to asc for non-date columns, desc for date
        this.sortDir = key === 'date' ? 'desc' : 'asc';
      }
      this.currentPage = 1;
    },
    // `gotoPage` removed (not used) to satisfy linter about unused methods
    prevPage() {
      if (this.currentPage > 1) this.currentPage -= 1;
    },
    nextPage() {
      if (this.currentPage < this.pageCount) this.currentPage += 1;
    },
    formatDate(d) {
      if (!d) return '';
      try {
        return new Date(d).toLocaleString('nl-BE');
      } catch (e) {
        return String(d);
      }
    },
    readableType(type) {
      if (!type) return 'Onbekend';
      const map = {
        [INCOMING_CHAT]: 'Chat',
        [INCOMING_EMAIL]: 'E-mail',
        [INCOMING_CALL]: 'Inkomende oproep',
        [OUTGOING_CALL]: 'Uitgaand oproep',
        [OUTGOING_CALL_BACKOFFICE]: 'Uitgaand (backoffice)',
        [MANUAL_OUTGOING_CALL_BACKOFFICE]: 'Handmatig uitgaand (BO)',
        [RECALL]: 'Terugbellen',
        [TELETOLK]: 'Teletolk',
        [EXTERNAL_TICKET]: 'Extern ticket',
      };
      return map[type] || type;
    }
  }
};
</script>

<style scoped>
.vlw_user_statistics {
    

    .vl-description-data__value {
        font-size: 1.9rem;
        font-weight: 600;
        padding-top: 0.25rem;
    }
}
/* Ensure form labels are displayed above their controls in this modal */

.vlw_user_statistics Datepicker {
  display: block;
  width: 100%;
}
  .vlw_user_statistics .sortable-header { 
    cursor: pointer; 
    display: inline-flex; 
    align-items: center; 
    gap: 0.5rem; 
}
  .vlw_user_statistics .sortable-header .vl-icon { margin-left: 0.25rem; }
</style>
